import { render, staticRenderFns } from "./card-review-detail.vue?vue&type=template&id=7fced78a&scoped=true"
import script from "./card-review-detail.vue?vue&type=script&lang=js"
export * from "./card-review-detail.vue?vue&type=script&lang=js"
import style0 from "./card-review-detail.vue?vue&type=style&index=0&id=7fced78a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fced78a",
  null
  
)

export default component.exports